import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

// 頁面組件
import Login from './pages/Login/Login';
import Layout from './pages/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Members from './pages/Members/Members';
import Agents from './pages/Agents/Agents';
import Reports from './pages/Reports/Reports';
import Profile from './pages/Profile/Profile';
import AdminMonitor from './pages/Admin/Monitor';
import AdminOdds from './pages/Admin/Odds';
import AdminLimits from './pages/Admin/Limits';
// AdminRanking 已移除

import './App.css';

function App() {
  return (
    <ConfigProvider locale={zhTW}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Navigate to="/dashboard" />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="members" element={<Members />} />
              <Route path="agents" element={<Agents />} />
              <Route path="reports/*" element={<Reports />} />
              <Route path="profile" element={<Profile />} />
              
              {/* 管理員專用路由 */}
              <Route path="admin/monitor" element={<AdminRoute><AdminMonitor /></AdminRoute>} />
              <Route path="admin/odds" element={<AdminRoute><AdminOdds /></AdminRoute>} />
              <Route path="admin/limits" element={<AdminRoute><AdminLimits /></AdminRoute>} />
              {/* admin/ranking 路由已移除 */}
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ConfigProvider>
  );
}

export default App;